import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import "./VendorTermsConditions.css";
import "./AddVendorOtherDetails.css";
import IosShareIcon from '@mui/icons-material/IosShare';

function AddVendorOtherDetails({ setShowDetailForms, userType,formSubmitted  }) {
  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;
  const [searchParm] = useSearchParams();
  const [currencies, setCurrencies] = useState([]);
  const [gstTreatment, setGstTreatment] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [vendorPANType, setVendorPANType] = useState([]);
  const [supplySource, setSupplySource] = useState([]);
  const [openingBalance, setOpeningBalance] = useState([]);
  const [vendorTDS, setVendorTDS] = useState([]);
  const [vendorDoc, setVendorDoc] = useState({
    GSTDocument: null,
    PANDocument: null,
    ChequeDocument: null,
    VRFDocument: null,
    MSMEDoc:null
  });
  const [filledData, setFilledData] = useState(null);
  const [isEditMode, setIsEditMode] = useState(true);
  const [OtherDetailForm, setOtherDetailForm] = useState({
    VendorGUID: "",
    VendorOtherDetailId: 0,
    GstTreatment: "",
    SupplySource: "",
    GstNumber: "",
    PanNumber: "",
    Currency: "",
    OpeningBalance: "",
    Amount: "",
    PaymentTerms: "",
    TDS: "",
    MSMENumber:"",
    MSMEDoc:"",
    PAN_Type: null,
    GSTDocument: null,
    PANDocument: null,
    ChequeDocument: null,
    VRFDocument: null,
    CreatedBy: userType,
    ModifiedBy: "null",
  });

  useEffect(() => {
    if (searchParm.get("vendorID") != null) {
      checkDataFilled(searchParm.get("vendorID"));

      setOtherDetailForm({
        ...OtherDetailForm,
        VendorGUID: searchParm.get("vendorID"),
        MSMERegistered: false,
      });
      getAllCurrencies();
      getGstTreatmentDetails();
      getPaymentTermsDetails();
      getSupplySourceDetails();
      getOpeningBalanceDetails();
      getTDSDetails();
      getPANType();
    }
  }, []);

  function checkDataFilled(id) {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    axios
      .get(`${baseAPI}admin/GETVendorDetailGUID?VendorID=${id}`, {})
      .then((response) => {
        if (response.data.data[0].VendorGUID != null) {
          setVendorDoc({
            GSTDocument: `${baseImageURL}Images/VendorDocuments/${response.data.data[0].GSTDocument}`,
            PANDocument: `${baseImageURL}Images/VendorDocuments/${response.data.data[0].PANDocument}`,
            ChequeDocument: `${baseImageURL}Images/VendorDocuments/${response.data.data[0].ChequeDocument}`,
            VRFDocument: `${baseImageURL}Images/VendorDocuments/${response.data.data[0].VRFDocument}`,
            MSMEDoc: `${baseImageURL}Images/VendorDocuments/${response.data.data[0].MSMEDoc}`,
          });
          setOtherDetailForm(response.data.data[0]);
          setFilledData(response.data.data);
          setIsEditMode(false);
          // setOtherDetailForm({
          //   VendorOtherDetailId: response.data.data[0].VendorOtherDetailId,
          //   VendorGUID: response.data.data[0].VendorGUID,
          //     GstTreatment: response.data.data[0].GstTreatment,
          //     SupplySource: response.data.data[0].SupplySource,
          //     GstNumber: response.data.data[0].GstNumber,
          //     PanNumber: response.data.data[0].PanNumber,
          //     Currency: response.data.data[0].Currency,
          //     OpeningBalance: response.data.data[0].OpeningBalance,
          //     Amount: response.data.data[0].Amount,
          //     PaymentTerms: response.data.data[0].PaymentTerms,
          //     TDS: response.data.data[0].TDS,
          //   GSTDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].GSTDocument}`,
          //   PANDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].PANDocument}`,
          //   ChequeDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].ChequeDocument}`,
          //   VRFDocument:`${baseImageURL}Images/VendorDocuments/${response.data.data[0].VRFDocument}`,
          // })
        }
      })
      .catch((error) => {
        console.error("Error fetching user detail:", error);
      });
  }

  function getAllCurrencies() {
    axios.get(`${baseAPI}Admin/GETCurrency`, {}).then((response) => {
      setCurrencies(response.data.data);
    });
  }

  function getGstTreatmentDetails() {
    axios
      .get(`${baseAPI}Admin/GETVendorGSTTreatmentDetails`, {})
      .then((response) => {
        setGstTreatment(response.data.data);
      });
  }

  function getPaymentTermsDetails() {
    axios
      .get(`${baseAPI}Admin/GETVendorPaymentTermsDetails`, {})
      .then((response) => {
        setPaymentTerms(response.data.data);
      });
  }

  function getSupplySourceDetails() {
    axios
      .get(`${baseAPI}Admin/GETVendorSupplySourceDetails`, {})
      .then((response) => {
        setSupplySource(response.data.data);
      });
  }

  function getOpeningBalanceDetails() {
    axios
      .get(`${baseAPI}Admin/GETVendorOpeningBalanceDetails`, {})
      .then((response) => {
        setOpeningBalance(response.data.data);
      });
  }

  function getTDSDetails() {
    axios.get(`${baseAPI}Admin/GETVendorTDSDetails`, {}).then((response) => {
      setVendorTDS(response.data.data);
    });
  }

  function getPANType() {
    axios.get(`${baseAPI}Admin/GETVendorPANType`, {}).then((response) => {
      setVendorPANType(response.data.data);
    });
  }

  function ResetForm() {
    setOtherDetailForm({
      GstTreatment: "",
      SupplySource: "",
      GstNumber: "",
      PanNumber: "",
      MSMERegistered: false,
      Currency: "",
      OpeningBalance: "",
      Amount: "",
      PaymentTerms: "",
      TDS: "",
      PAN_Type: 0,
      VendorGUID: searchParm.get("vendorID"),
    });
  }

  function isValidFileType(file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    return file && allowedTypes.includes(file.type);
  }

  function handleChange(e) {
    if (isEditMode) {
      const { name, value, files } = e.target;

      if (
        name === "GSTDocument" ||
        name === "PANDocument" ||
        name === "ChequeDocument" ||
        name === "VRFDocument" ||
        name==="MSMEDoc"
      ) {
        const file = files[0];
        if (isValidFileType(file)) {
          getUpdatedImage(file, name);
        } else {
          alert("Unsupported file type. Please upload a valid file.");
        e.target.value = null;
          return;
        }
      }
      else if(name==="GstNumber"){
        let newValue=value.toUpperCase()
        setOtherDetailForm({...OtherDetailForm,[name]:newValue})
        if(newValue.length>5){
          const automatedPanNumber=newValue.slice(2,-3)
      
          setOtherDetailForm({...OtherDetailForm,[name]:newValue,PanNumber:automatedPanNumber})
        }
        // if(value===""){
        //   setOtherDetailForm({...OtherDetailForm,[name]:value,PanNumber:""})
        // }
      }
      else if (name === "MSMERegistered") {
        let checkbox = document.getElementById("checkbox");
        setOtherDetailForm({
          ...OtherDetailForm,
          [name]: checkbox.checked,
        });
      } else {
        setOtherDetailForm({
          ...OtherDetailForm,
          [name]: value,
        });
      }
    }
  }


  function getUpdatedImage(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setOtherDetailForm({
          ...OtherDetailForm,
          [name]: imageData,
        });
      };

      reader.readAsDataURL(file);
    }
  }

  function showClickedForm() {
    const newObj = {
      AddressForm: false,
      OtherDetailsForm: false,
      BankDetailsForm: false,
      ContactDetailsForm: false,
      TermsForm: false,
    };

    newObj.BankDetailsForm = true;
    setShowDetailForms(newObj);
  }

  function validatePAN(pan) {
    const pattern = /^[A-Z]{5}\d{4}[A-Z]$/;
    return pattern.test(pan);
  }

  const handleSubmit = async (e) => {
    let updatedData = {};
    if (OtherDetailForm && OtherDetailForm.VendorOtherDetailId !== 0) {
      updatedData = {
        ...OtherDetailForm,
        CreatedBy: userType,
      };
    } else {
      updatedData = {
        ...OtherDetailForm,
      };
    }

    if (
      OtherDetailForm.GstTreatment === "" ||
      OtherDetailForm.SupplySource === ""
    ) {
      alert("GST Treatment and Supply Source are neccessary fields");
      return;
    }

    if (OtherDetailForm.PanNumber !== "") {
      const validation = validatePAN(OtherDetailForm.PanNumber);
      if (!validation) {
        alert("Pan Number is not valid");
        return;
      }
    }

    showClickedForm();
    e.preventDefault();
    if (!isEditMode) {
      setOtherDetailForm({
        ...OtherDetailForm,
        VendorOtherDetailId: 0,
      });
    }

    try {
      const response = await axios.post(
        `${baseAPI}Admin/AddVendorOtherDetail`,
        updatedData
      );
      checkDataFilled(searchParm.get("vendorID"));
      setOtherDetailForm({
        VendorGUID: "",
        GstTreatment: "",
        SupplySource: "",
        GstNumber: "",
        PanNumber: "",
        MSMERegistered: false,
        MSMENumber:"",
        MSMEDoc:null,
        Currency: "",
        OpeningBalance: "",
        Amount: "",
        PaymentTerms: "",
        TDS: "",
        GSTDocument: null,
        PANDocument: null,
        ChequeDocument: null,
        VRFDocument: null,
      });
    } catch (error) {
      console.error("Error posting data:", error);
    }
  };

  function AllowEditingData() {
    setIsEditMode(true);
  }

  function cancelEdit() {
    checkDataFilled();
    checkDataFilled(searchParm.get("vendorID"));
  }

  return (
    <div className="container-fluid">
      <div className=" vendor_other_detail_main_div">
        <table className="form-table">
          <tbody className="row">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <tr>
                <td style={{ color: "red" }} className="form-label">
                  GST Treatment*
                </td>
                <select
                  className="form-control"
                  name="GstTreatment"
                  onChange={handleChange}
                  value={OtherDetailForm.GstTreatment}
                >
                  <option value="0">Select an option</option>
                  {gstTreatment.map((item) => (
                    <option key={item.Tseed} value={item.Tseed}>
                      {item.GSTTreatment_Type}- ({item.Gst_Description})
                    </option>
                  ))}
                </select>
              </tr>

              <tr>
                <td className="form-label">GST Number</td>
                <input
                  type="text"
                  name="GstNumber"
                  placeholder="Please Enter*"
                  value={OtherDetailForm.GstNumber}
                  onChange={handleChange}
                required
                />
              </tr>

              <tr>
                <td className="form-label">
                  <span style={{ padding: "0 8px 18px 7px" }}>
                    MSME Registered?
                  </span>
                  {filledData !== null && !isEditMode ? (
                    <input
                      type="checkbox"
                      id="checkbox"
                      checked={filledData[0].MSMERegistered}
                      name="MSMERegistered"
                      onChange={handleChange}
                      style={{
                        position: "absolute",
                        marginLeft: "20px",
                        marginTop: "-10px",
                        paddingTop: "26px",
                        width: "12px",
                        marginBottom: "-14px",
                      }}
                    />
                  ) : (
                    <input
                      type="checkbox"
                      id="checkbox"
                      checked={OtherDetailForm.MSMERegistered}
                      name="MSMERegistered"
                      onChange={handleChange}
                      style={{
                        position: "absolute",
                        marginLeft: "20px",
                        marginTop: "-10px",
                        paddingTop: "26px",
                        width: "12px",
                        marginBottom: "-14px",
                      }}
                    />
                  )}
                </td>

                {/* <td className="form-label">MSME Registered?</td>
              {filledData!==null && !isEditMode?
              <input
              type="checkbox"
              id="checkbox"
              checked={filledData[0].MSMERegistered} 
              name="MSMERegistered"
              onChange={handleChange}
            />
            :
            <input
            type="checkbox"
            id="checkbox"
            checked={OtherDetailForm.MSMERegistered}
            name="MSMERegistered"
            onChange={handleChange}
          />
            } */}
              </tr>

          {/* //  */}
          {OtherDetailForm.MSMERegistered?
           <tr>
           <td className="form-label">MSME Number</td>
           <input
             type="number"
             name="MSMENumber"
             value={OtherDetailForm.MSMENumber}
             placeholder="Please Enter*"
             onChange={handleChange}
             required
           />
         </tr>
          :
          null}
             
          {/*  */}

              <tr>
                <td className="form-label">Currency</td>
                <select
                  className="form-control"
                  name="Currency"
                  onChange={handleChange}
                  value={OtherDetailForm.Currency}
                >
                  <option value="0">Select an option</option>
                  {currencies.map((currency) => (
                    <option
                      key={currency.CurrencyID}
                      value={currency.CurrencyID}
                    >
                      {currency.CurrencyCode}
                    </option>
                  ))}
                </select>
              </tr>
              <tr>
                <td className="form-label">Payment Terms</td>
                <select
                  className="form-control"
                  name="PaymentTerms"
                  onChange={handleChange}
                  value={OtherDetailForm.PaymentTerms}
                >
                  <option value="0">Select an option</option>
                  {paymentTerms.map((item) => (
                    <option key={item.Tseed} value={item.Tseed}>
                      {item.Payment_Type}
                    </option>
                  ))}
                </select>
              </tr>
              <tr className="vendor-other-detail-tr-new">
                <td className="form-label">GST Document</td>
                {filledData === null ? (
                  <input
                    id="GSTDocument"
                    type="file"
                    name="GSTDocument"
                    onChange={handleChange}
                  />
                ) : isEditMode ? (
                  <td className="p-0 m-0" style={{display:"flex"}}>
                  <input
                 type="file"
                 name="GSTDocument"
                 onChange={handleChange}
                 required
               />
                 {OtherDetailForm.GSTDocument?
                         <a className="px-2 text-center" style={{border:"none",color:"#00A3FF",width:"33%",marginLeft:"7px"}} target="_blank" href={vendorDoc.GSTDocument}>
                           View Document
                           <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>
                         </a>
                         :
                         <a className="px-2" style={{width:"33%",marginLeft:"7px",border:"none",color:"#00A3FF"}}>
                     No File Uploaded
                       </a>
                         }
                 </td>
                ) : (
                  OtherDetailForm.GSTDocument?
                    <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}} target="_blank" href={vendorDoc.GSTDocument}>
                      View Document
                      <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>

                    </a>
                    :
                    <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}}>
                No File Uploaded

                  </a>
                    
                )}
              </tr>
              <tr className="vendor-other-detail-tr-new">
                <td className="form-label">Cheque Document</td>
                {filledData === null ? (
                  <input
                    id="ChequeDocument"
                    type="file"
                    name="ChequeDocument"
                    onChange={handleChange}
                  />
                ) : isEditMode ? (
                  <td className="p-0 m-0" style={{display:"flex"}}>
                  <input
                 type="file"
                 name="ChequeDocument"
                 onChange={handleChange}
                 required
               />
                 {OtherDetailForm.ChequeDocument?
                         <a className="px-2 text-center" style={{width:"33%",marginLeft:"7px",border:"none",color:"#00A3FF"}} target="_blank" href={vendorDoc.ChequeDocument}>
                           View Document
                           <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>
                         </a>
                         :
                         <a className="px-2" style={{width:"33%",marginLeft:"7px",border:"none",color:"#00A3FF"}}>
                     No File Uploaded
                       </a>
                         }
                 </td>
                ) : (
                  OtherDetailForm.ChequeDocument?
                    <a className="p-0" style={{fontWeight:"bold",color:"#00A3FF",border:"none"}} target="_blank" href={vendorDoc.ChequeDocument}>
                      View Document
                      <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>
                    </a>

                    :
                    <a className="p-0" style={{fontWeight:"bold",color:"#00A3FF",border:"none"}}>
                No File Uploaded
                  </a>
                )}
              </tr>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              <tr>
                <td style={{ color: "red" }} className="form-label">
                  Source Of Supply*
                </td>
                <select
                  className="form-control"
                  name="SupplySource"
                  value={OtherDetailForm.SupplySource}
                  onChange={handleChange}
                >
                  <option value="0">Select an option</option>
                  {supplySource.map((item) => (
                    <option key={item.Tseed} value={item.Tseed}>
                      [{item.State_Code}] {item.State_Name}
                    </option>
                  ))}
                </select>
              </tr>
              <tr>
                <td className="form-label">PAN</td>
                <input
                  type="text"
                  name="PanNumber"
                  value={OtherDetailForm.PanNumber}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                  required
                />
              </tr>
              {/*  */}
              {OtherDetailForm.MSMERegistered?
          <tr className="px-2 vendor-other-detail-tr-new vendor-other-detail-msme" style={{marginTop:"52px"}}>
          <td className="form-label">MSME Document</td>
          {filledData === null ? (
           <input
           type="file"
           name="MSMEDoc"
           onChange={handleChange}
           required
         />
          ) : isEditMode ? (
            <td className="p-0 m-0" style={{display:"flex"}}>
             <input
            type="file"
            name="MSMEDoc"
            onChange={handleChange}
            required
          />
            {OtherDetailForm.MSMEDoc?
                    <a className="px-2 text-center" style={{border:"none",color:"#00A3FF",width:"33%",marginLeft:"7px"}} target="_blank" href={vendorDoc.MSMEDoc}>
                      View Document
                      <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>

                    </a>
                    :
                    <a className="p-0" style={{width:"33%",border:"none",color:"#00A3FF"}}>
                No File Uploaded
                  </a>
                    }
            </td>
          ) : (
            OtherDetailForm.MSMEDoc?
            <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}} target="_blank" href={vendorDoc.MSMEDoc}>
              View Document
              <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>

            </a>
            :
            <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}}>
        No File Uploaded

          </a>
          )}
        </tr>
         :
         null
         }
              <tr style={{ height: "51px" }}></tr>
              <div className="row" style={{marginTop:OtherDetailForm.MSMERegistered?"-52px":""}}>
                <div style={{ margin: "7px 0px -7px" }} class="col-6">
                  <td
                    style={{
                      color: "#6A6A6A",
                      fontWeight: "bold",
                      color: "#6a6a6a",
                      padding: "9px",
                    }}
                    className="form-label"
                  >
                    Balance
                  </td>
                  <select
                    style={{
                      border: "1px solid #5b489d",
                      color: "#6a6a6a",
                      width: "100%",
                      height: "45px",
                      padding: "8px;",
                      borderRadius: "6px",
                      position: "relative",
                    }}
                    id="opening_input"
                    className="form-control"
                    name="OpeningBalance"
                    onChange={handleChange}
                    value={OtherDetailForm.OpeningBalance}
                  >
                    <option value="0">Select an option</option>
                    {openingBalance.map((item) => (
                      <option key={item.Tseed} value={item.Tseed}>
                        {item.OpeningBalance_Type}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ margin: "65px 0px 0px" }} class="col-6">
                  <input
                    style={{
                      border: "1px solid #5b489d",
                      color: "#6a6a6a",
                      width: "100%",
                      height: "45px",
                      marginTop: "-15px",
                      padding: "8px;",
                      borderRadius: "6px",
                      position: "relative",
                    }}
                    id="opening_input"
                    type="number"
                    name="Amount"
                    placeholder="INR"
                    onChange={handleChange}
                    value={OtherDetailForm.Amount}
                    required
                  />
                </div>
              </div>
              {/* <tr>
              <td className="form-label">TDS</td>
              <select
                 className="form-control"
                 name="TDS"
                 onChange={handleChange}
                 value={
                   OtherDetailForm.TDS
                 }
                >
                  <option value="0">Select an option</option>
                  {vendorTDS.map((item) => (
                    <option key={item.Tseed} value={item.Tseed}>
                    {item.TDS_Category}
                  </option>
                  ))}
                </select>
               
            </tr> */}
              <div style={{ marginBottom: "-8px" }} class="row">
                <div style={{ margin: "7px 0px -7px" }} class="col-6">
                  <td
                    style={{
                      color: "#6A6A6A",
                      fontWeight: "bold",
                      color: "#6a6a6a",
                      padding: "9px",
                    }}
                    className="form-label"
                  >
                    TDS
                  </td>
                  <select
                    style={{
                      border: "1px solid #5b489d",
                      color: "#6a6a6a",
                      width: "100%",
                      height: "45px",
                      padding: "8px;",
                      borderRadius: "6px",
                      position: "relative",
                    }}
                    id="opening_input"
                    className="form-control"
                    name="TDS"
                    onChange={handleChange}
                    value={OtherDetailForm.TDS}
                  >
                    <option value="0">Select an option</option>
                    {vendorTDS.map((item) => (
                      <option key={item.Tseed} value={item.Tseed}>
                        {item.TDS_Category}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{ margin: "6px -8px 0px" }} class="col-6">
                  <td
                    style={{
                      color: "#6A6A6A",
                      fontWeight: "bold",
                      color: "#6a6a6a",
                      padding: "9px",
                    }}
                    className="form-label"
                  >
                    PAN Type
                  </td>{" "}
                  <select
                    style={{
                      border: "1px solid #5b489d",
                      color: "#6a6a6a",
                      width: "100%",
                      height: "45px",
                      padding: "8px;",
                      borderRadius: "6px",
                      position: "relative",
                    }}
                    id="opening_input"
                    className="form-control"
                    name="PAN_Type"
                    onChange={handleChange}
                    value={OtherDetailForm.PAN_Type}
                  >
                    <option value="0">Select an option</option>
                    {OtherDetailForm.TDS == 1
                      ? vendorPANType.map((item) => (
                          <option key={item.Tseed} value={item.Tseed}>
                            {item.PAN_Type}
                          </option>
                        ))
                      : null}
                  </select>
                </div>
              </div>

              <tr className="px-2 vendor-other-detail-tr-new">
                <td className="form-label">PAN Document</td>
                {filledData === null ? (
                  <input
                    id="PANDocument"
                    type="file"
                    name="PANDocument"
                    onChange={handleChange}
                  />
                ) : isEditMode ? (
                  <td className="p-0 m-0" style={{display:"flex"}}>
                  <input
                 type="file"
                 name="PANDocument"
                 onChange={handleChange}
                 required
               />
                 {OtherDetailForm.PANDocument?
                         <a className="px-2 text-center" style={{width:"33%",marginLeft:"7px",border:"none",color:"#00A3FF"}} target="_blank" href={vendorDoc.PANDocument}>
                           View Document
                           <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>
                         </a>
                         :
                         <a className="px-2" style={{width:"33%",marginLeft:"7px",border:"none",color:"#00A3FF"}}>
                     No File Uploaded
                       </a>
                         }
                 </td>
                ) : (
                  OtherDetailForm.PANDocument?
                    <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}} target="_blank" href={vendorDoc.PANDocument}>
                      View Document
                      <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>

                    </a>
                    :
                    <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}}>
                No File Uploaded

                  </a>
                )}
              </tr>
  
              <tr className="px-2 vendor-other-detail-tr-new">
                <td className="form-label">VRF Document</td>
                {filledData === null ? (
                  <>
                    <input
                      id="VRFDocument"
                      type="file"
                      name="VRFDocument"
                      onChange={handleChange}
                    />
                    <td
                      style={{
                        position: "relative",
                        top: "-23px",
                        color: "#6a6a6a",
                        color: "rgb(175 163 163)",
                        fontSize: "11px",
                      }}
                    >
                      You can upload a maximum of 4 files, 1 MB each
                    </td>
                  </>
                ) : isEditMode ? (
                  <td className="p-0 m-0" style={{display:"flex"}}>
                  <input
                 type="file"
                 name="VRFDocument"
                 onChange={handleChange}
                 required
               />
                 {OtherDetailForm.VRFDocument?
                         <a className="px-2 text-center" style={{border:"none",width:"33%",marginLeft:"7px",color:"#00A3FF"}} target="_blank" href={vendorDoc.VRFDocument}>
                           View Document
                           <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>
                         </a>
                         :
                         <a className="px-2" style={{width:"33%",marginLeft:"7px",color:"#00A3FF",border:"none"}}>
                     No File Uploaded
                       </a>
                         }
                 </td>
                ) : (
                  OtherDetailForm.VRFDocument?
                    <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}} target="_blank" href={vendorDoc.VRFDocument}>
                      View Document
                      <IosShareIcon style={{marginTop:"-7px",marginLeft:"4px",fontSize:"22px",color:"#00A3FF"}}/>

                    </a>
                    :
                    <a className="p-0" style={{border:"none",color:"#00A3FF",fontWeight:"bold"}}>
                No File Uploaded

                  </a>
                )}
              </tr>
            </div>
          </tbody>
        </table>
      </div>

      {/* Paragraph */}
      <div
        style={{ width: "100%" }}
        className="d-flex vendor_other_detail_content_para"
      >
        <div
          style={{ marginRight: "10px" }}
          className="flex-fill vendor_other_detail_payment "
        >
          <h1>Payment Terms</h1>
          <p>
            Bills between 1st-15th of every month shall be settled on 20th of
            every month and bills between 16th-30th/31st of every month shall be
            settled on 5th of following month
          </p>
        </div>
        <div className=" flex-fill vendor_other_detail_document">
          <h1>Documentation</h1>
          <ul>
            <li>1. GST Certificate (if available)</li>
            <li>2. PAN Card</li>
            <li>3. Cancelled Cheque Copy</li>
            <li>4. Vendor Registration Form</li>
          </ul>
        </div>
      </div>

      <br />
      <hr />

      <div
        className={`text-center buttons_main_div  mobile_buttons_main_div ${
          userType === "admin" ? "admin_type_other_buttons_main_div" : ""
        }`}
      >
        {filledData !== null ? (
           formSubmitted?
           null
           :
          <button
            style={{
              backgroundColor: "white",
              border: "none",
              color: "red",
            }}
            className="btn btn-warning ml-2"
            onClick={cancelEdit}
          >
            Cancel
          </button>
        ) : (
          formSubmitted?
          null
          :
          <button
            style={{
              backgroundColor: "white",
              border: "none",
              color: "red",
            }}
            className="btn btn-warning ml-2"
            onClick={ResetForm}
          >
            Reset
          </button>
        )}
        {filledData === null ? (
            formSubmitted?
            null
            :
          <button
            style={{
              backgroundColor: "#5B489D",
              color: "white",
            }}
            className="btn btn-success"
            onClick={handleSubmit}
          >
            Next{" "}
          </button>
        ) : isEditMode ? (
          formSubmitted?
          null
          :
          <button
            style={{
              backgroundColor: "#5B489D",
              color: "white",
            }}
            className="btn btn-success"
            onClick={handleSubmit}
          >
            Update{" "}
          </button>
        ) : (
          formSubmitted?
          null
          :
          <button
            style={{
              backgroundColor: "#5B489D",
              color: "white",
            }}
            className="btn btn-success"
            onClick={AllowEditingData}
          >
            Edit{" "}
          </button>
        )}
      </div>
    </div>
  );
}

export default AddVendorOtherDetails;
